/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FufiContractSavingsDto
 */
export interface FufiContractSavingsDto {
    /**
     * 
     * @type {string}
     * @memberof FufiContractSavingsDto
     */
    proposalNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FufiContractSavingsDto
     */
    contractNumber: string;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    inPoolCashValueDeemed: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    inPoolCashValueReal: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    accPoolCashValue: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    ae28CashValue: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    cashValue: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    surrenderValue: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    pendingDeduction: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    maxPartialSurrender: number;
    /**
     * 
     * @type {number}
     * @memberof FufiContractSavingsDto
     */
    uninvestedAmount: number;
}

/**
 * Check if a given object implements the FufiContractSavingsDto interface.
 */
export function instanceOfFufiContractSavingsDto(value: object): value is FufiContractSavingsDto {
    if (!('proposalNumber' in value) || value['proposalNumber'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    if (!('inPoolCashValueDeemed' in value) || value['inPoolCashValueDeemed'] === undefined) return false;
    if (!('inPoolCashValueReal' in value) || value['inPoolCashValueReal'] === undefined) return false;
    if (!('accPoolCashValue' in value) || value['accPoolCashValue'] === undefined) return false;
    if (!('ae28CashValue' in value) || value['ae28CashValue'] === undefined) return false;
    if (!('cashValue' in value) || value['cashValue'] === undefined) return false;
    if (!('surrenderValue' in value) || value['surrenderValue'] === undefined) return false;
    if (!('pendingDeduction' in value) || value['pendingDeduction'] === undefined) return false;
    if (!('maxPartialSurrender' in value) || value['maxPartialSurrender'] === undefined) return false;
    if (!('uninvestedAmount' in value) || value['uninvestedAmount'] === undefined) return false;
    return true;
}

export function FufiContractSavingsDtoFromJSON(json: any): FufiContractSavingsDto {
    return FufiContractSavingsDtoFromJSONTyped(json, false);
}

export function FufiContractSavingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiContractSavingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'proposalNumber': json['proposalNumber'],
        'contractNumber': json['contractNumber'],
        'inPoolCashValueDeemed': json['inPoolCashValueDeemed'],
        'inPoolCashValueReal': json['inPoolCashValueReal'],
        'accPoolCashValue': json['accPoolCashValue'],
        'ae28CashValue': json['ae28CashValue'],
        'cashValue': json['cashValue'],
        'surrenderValue': json['surrenderValue'],
        'pendingDeduction': json['pendingDeduction'],
        'maxPartialSurrender': json['maxPartialSurrender'],
        'uninvestedAmount': json['uninvestedAmount'],
    };
}

export function FufiContractSavingsDtoToJSON(json: any): FufiContractSavingsDto {
    return FufiContractSavingsDtoToJSONTyped(json, false);
}

export function FufiContractSavingsDtoToJSONTyped(value?: FufiContractSavingsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proposalNumber': value['proposalNumber'],
        'contractNumber': value['contractNumber'],
        'inPoolCashValueDeemed': value['inPoolCashValueDeemed'],
        'inPoolCashValueReal': value['inPoolCashValueReal'],
        'accPoolCashValue': value['accPoolCashValue'],
        'ae28CashValue': value['ae28CashValue'],
        'cashValue': value['cashValue'],
        'surrenderValue': value['surrenderValue'],
        'pendingDeduction': value['pendingDeduction'],
        'maxPartialSurrender': value['maxPartialSurrender'],
        'uninvestedAmount': value['uninvestedAmount'],
    };
}

